/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/DraftCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components } from "VSS/Platform/Layout";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

export const DraftCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    const identityId = getPropertyValue(props.thread, "CodeReviewIsDraftUpdatedByIdentity");
    const identity = getIdentity(props.thread, identityId);
    if (!isShim) {
        if (!identity) {
            return null;
        }

        const set = getPropertyValue(props.thread, "CodeReviewIsDraftNowSet") === "1";

        let format;
        if (set) {
            format = Resources.ActivityFeedDraftSet;
        } else {
            format = Resources.ActivityFeedDraftCleared;
        }

        return (
            <ActivityCardSubtle createDate={props.thread.publishedDate}>
                <FormatComponent elementType={null} format={format}>
                    {getIdentityComponent(identity, "activity-card-first-image")}
                </FormatComponent>
            </ActivityCardSubtle>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <ActivityShimmer />
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.draft-activity-card", DraftCard);
